module.exports = __webpack_public_path__ + "static/img/iconfont.99d517b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/css/iconfont.svg?t=1563512667293
// module id = ghEJ
// module chunks = 21